var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#060B27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5211 16.5443C32.2371 17.2602 32.2371 18.4146 31.5211 19.1305L26.6116 24.0327L31.5211 28.9422C32.2371 29.6582 32.2371 30.8125 31.5211 31.5284C30.8052 32.2444 29.6509 32.2444 28.9349 31.5284L24.0327 26.619L19.1232 31.5284C18.4073 32.2444 17.2529 32.2444 16.537 31.5284C15.821 30.8125 15.821 29.6582 16.537 28.9422L21.4465 24.0327L16.537 19.1232C15.821 18.4073 15.821 17.2529 16.537 16.537C17.2529 15.821 18.4073 15.821 19.1232 16.537L24.0327 21.4465L28.9422 16.537C29.6509 15.8283 30.8125 15.8283 31.5211 16.5443Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.4aa6dd46a099458145df8c026dd2146e.svg";
export { ForwardRef as ReactComponent };